import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 30"
    x="0px"
    y="0px"
    className={className}
  >
    <path d="M6,14a1,1,0,0,1-1-1V2A1,1,0,0,1,7,2V13A1,1,0,0,1,6,14Z" />
    <path d="M8,20H6a1,1,0,0,1-.71-1.71,1,1,0,0,1,1.42,0,1,1,0,1,0,1.41-1.41,3.08,3.08,0,0,0-4.24,0A3,3,0,0,0,3,19a3.05,3.05,0,0,0,.18,1H3a1,1,0,0,0,0,2H8a1,1,0,0,0,0-2Z" />
    <circle cx="11.5" cy="12.5" r="1.5" />
    <path d="M19.31,14H17a1,1,0,0,1,0-2h2.31a.65.65,0,0,0,.56-.37,1,1,0,0,0,0-1L17.08,6.56a1,1,0,0,1,1.66-1.12l2.8,4.12a3,3,0,0,1,.08,3A2.65,2.65,0,0,1,19.31,14Z" />
  </svg>
);
